import FileInput from '../utils/class/fileInput';

export default class Contacts {
    constructor(query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.hasPlayedLogoAnimation = false;

        this.init();
    }

    init() {
        this.initFileInputs();
        this.initLogoAnimation();
    }

    initFileInputs() {
        new FileInput({
            root: this.el,
        });
    }

    initLogoAnimation() {
        this.logoAnimation = this.el.querySelector('.js-logo-gradient-animation');

        if (!this.logoAnimation) return;

        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting || this.hasPlayedLogoAnimation) return;

                    this.playLogoAnimation();
                    this.hasPlayedLogoAnimation = true;
                    this.observer.disconnect();
                });
            },
            {
                threshold: 0.35,
            }
        );

        this.observer.observe(this.el);
    }

    playLogoAnimation() {
        if (!this.logoAnimation || typeof this.logoAnimation.beginElement !== 'function') return;

        this.logoAnimation.beginElement();
    }
}